import { combineReducers } from 'redux';

import userObjectReducer from '../commonReducers/userObjectReducer';
import userIdentityReducer from '../commonReducers/userIdentityReducer';
import communicationPreferencesReducer from '../commonReducers/communicationPreferencesReducer';
import translationDataReducer from '../commonReducers/translationDataReducer';
import configsDataReducer from '../commonReducers/configsDataReducer';
import queryParamsReducer from '../commonReducers/queryParamsReducer';
import ssoReducer from '../commonReducers/ssoReducer';
import fontReducer from '../commonReducers/fontReducer';
import userHashReducer from '../commonReducers/userHashReducer';
import userTypeReducer from '../commonReducers/userTypeReducer';

const allReducers = combineReducers({
  userIdentityDetails: userIdentityReducer,
  userObject: userObjectReducer,
  userHash: userHashReducer,
  preferencesData : communicationPreferencesReducer,
  translationsData: translationDataReducer,
  configs: configsDataReducer,
  queryParams: queryParamsReducer,
  sso: ssoReducer,
  fontData: fontReducer,
  userTypeDetails: userTypeReducer
})

export default function getWidgetReducers() {
  return allReducers;
}
